import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { messageSVC } from "message/service"
import { IUserTag } from "user-tag/model"
import { tagRPO } from "user-tag/repository"
import { tagActionCreator } from "user-tag/store/actions"
import { getUserId } from "user/tools/common"

export const getAllUserTags = (): Promise<IUserTag[]> => tagRPO.getAllUserTags(getUserId())

export const getAllUserTagsInStore = (): IUserTag[] => getStore().getState().tag.userTags

export const getTagNamesByIds = (tagIds: number[]): string[] =>
  getAllUserTagsInStore()
    .filter(t => tagIds.includes(t.id))
    .map(t => t.name)

export const createUserTag = async (tag: string): Promise<IUserTag> => {
  const newUserTag = await tagRPO.createUserTag(getUserId(), tag)
  getStore().dispatch(tagActionCreator.addUserTag(newUserTag))
  return newUserTag
}

export const deleteUserTag = async (userTagId: number, tagName: string): Promise<void> => {
  messageSVC.confirmMessage({
    message: translate("tag.delete.message", tagName),
    title: translate("tag.delete"),
    onSuccess: async () => {
      try {
        await tagRPO.deleteUserTag(getUserId(), userTagId)
        getStore().dispatch(tagActionCreator.deleteUserTag(userTagId))
      } catch (error) {
        console.error(error)
        messageSVC.error(translate("tag.deleting.error", tagName || "-"))
      }
    }
  })
}
